import { render, staticRenderFns } from "./OrderStats.vue?vue&type=template&id=13253eea&scoped=true"
import script from "./OrderStats.vue?vue&type=script&lang=js"
export * from "./OrderStats.vue?vue&type=script&lang=js"
import style0 from "./OrderStats.vue?vue&type=style&index=0&id=13253eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13253eea",
  null
  
)

export default component.exports